import {getEntity} from '@ngneat/elf-entities';

import {getIssueKindDataSource} from '@store/settings/issueKinds/issueKinds.requests';
import {issueKindsStore} from '@store/settings/issueKinds/issueKinds.store';

export class IssueKindsQuery {
    store = issueKindsStore;

    issueKinds$ = getIssueKindDataSource.data$();

    issueKindById = (issueKindId: number) => this.store.query(getEntity(issueKindId));
}

export const issueKindsQuery = new IssueKindsQuery();